import WidgetModule from "@eisinc/Overrides/Widgets/Basic/PageTitle";

export * from "@eisinc/Overrides/Widgets/Basic/PageTitle";

export default WidgetModule;
